import { isWiseUiEnabled } from 'config/wiseUi';

import LegacyFooter from './Footer';
import WiseFooter from 'components/wise/WiseFooter';

const Footer = isWiseUiEnabled() ? WiseFooter : LegacyFooter;

export default Footer;
